import { ROUTES } from '@/router/routeNames'

export default [
  {
    path: 'campaigns',
    children: [
      {
        name: ROUTES.CAMPAIGNS,
        path: '',
        component: () => import('./pages/CampaignsIndex.vue'),
        meta: {
          title: 'Website Personalization Campaigns',
          description: `Personalize any content on your website based on the segmentation data that RightMessage helps collect, or from data that already exists for a known contact in your email platform.`,
          //helpDoc: 'personalizationCampaigns.default'
          // rightyPrompts: [
          //   {
          //     label: 'Create a campaign',
          //     prompt: 'Help me create a new website personalization campaign. I want to personalize content on my website for different visitor segments.'
          //   },
          //   {
          //     label: 'Analyze performance',
          //     prompt: 'Analyze my campaign performance. Show me which campaigns are performing best and where I can improve.'
          //   },
          //   {
          //     label: 'Quick wins',
          //     prompt: 'Identify high-traffic pages that aren\'t being personalized yet. What easy personalization wins am I missing?'
          //   },
          //   {
          //     label: 'Test ideas',
          //     prompt: 'Suggest A/B testing ideas for my personalization campaigns. What should I test next to improve results?'
          //   }
          // ]
        }
      },
      {
        name: ROUTES.CREATECAMPAIGN,
        path: 'new',
        component: () => import('./pages/CampaignCreate.vue'),
        meta: {
          title: 'New Website Personalization Campaign'
        }
      },
      {
        name: ROUTES.CAMPAIGN,
        path: ':campaignId',
        component: () => import('./pages/CampaignShow.vue'),
        props: true,
        meta: {
          rightyPrompts: [
            {
              label: 'Optimize variants',
              drawerLabel: 'How can I optimize these variants?',
              prompt: 'Analyze the variants in this campaign {{campaignId}}. How can I improve the targeting rules and personalization content?'
            },
            {
              label: 'Check consistency',
              drawerLabel: 'Check my messaging consistency',
              prompt: 'Review the messaging across all variants in this campaign {{campaignId}}. Is the personalization consistent and does it align with my brand?'
            },
            {
              label: 'Performance analysis',
              drawerLabel: 'How is this campaign performing?',
              prompt: 'How is this campaign {{campaignId}} performing? Compare the control group vs personalized variants and show me the impact.'
            }
          ]
        }
      }
    ]
  },
  {
    path: 'emails',
    children: [
      {
        name: ROUTES.EMAILS,
        path: '',
        component: () => import('./pages/EmailsIndex.vue'),
        meta: {
          title: 'Personalized Emails',
          description: `Using the data RightMessage helps you collect, it's now easier than ever to create highly personalized emails.`
        }
      },
      {
        name: ROUTES.EMAIL,
        path: ':emailId',
        component: () => import('./pages/EmailShow.vue'),
        props: true,
        meta: {
          fullScreen: true,
          rightyModule: 'email',
          rightyPrompts: [
            {
              label: 'Personalize',
              drawerLabel: 'Add personalization to this email',
              prompt: 'Help me add Liquid conditionals to this email so the SAME email adapts for different segments. I want ONE email template that personalizes inline - NOT separate emails per segment. First, recommend which dimensions/segments would work well for this email.'
            },
            {
              label: 'Write content',
              drawerLabel: 'Write personalized email content',
              prompt: 'Help me write a SINGLE email template with Liquid conditionals that personalizes content inline for different segments. I want ONE email that adapts - NOT separate emails per segment. First, recommend a few topic ideas before writing.'
            }
          ]
        }
      }
    ]
  },
  {
    path: 'goals',
    children: [
      {
        name: ROUTES.GOALS,
        path: '',
        component: () => import('./pages/GoalsIndex.vue'),
        meta: {
          title: 'Conversion Goals',
          description: `Conversion goals can be associated with a campaign, and are used to indicate the success of a campaign. When one or more goals are attached to a personalization campaign, we'll automatically run an A/B test on the campaign to determine what impact personalization is having.`
        }
      },
      {
        name: ROUTES.CREATEGOAL,
        path: 'new',
        component: () => import('./pages/GoalCreate.vue')
      }
    ]
  }
]
